module.exports = __webpack_public_path__ + "media/components/assets/images/tamgeulAllkill/image7-1b6e8ebe83c11f8b56c4e59d0179c603.png";